export default function PackageVersionTag(): React.ReactElement {
  return (
    <span data-testid="package-version-tag" className="hidden">
      {__APP_VERSION__}
    </span>
  );
}
